import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about">
      <h2>A proposito di me</h2>
      <div className="about-content">
        <div className="about-image">
          <img src={`${process.env.PUBLIC_URL}/alessandro.jpg`} alt="Alessandro Bejinaru" />
        </div>
        <div className="about-text">
          <p>
            Mi chiamo <strong>Alessandro Bejinaru</strong>, ho 16 anni e sono uno studente del liceo 
            scientifico dell'Istituto Elvetico di Lugano. Fin da piccolo ho avuto una passione per 
            la lettura e la scrittura, sono sempre stato innamorato della meraviglia e delle belle storie.
          </p>
          <p>
            Ho continuato a coltivare questa passione, che ho coronato con la vittoria nel 2021 del 
            concorso letterario <strong><a href="https://www.castellidicarta.ch/index.php?p=2021" target="_blank" rel="noopener noreferrer" style={{color: '#0099cc', textDecoration: 'none'}}>"Castelli di Carta"</a></strong> organizzato dalla Biblioteca cantonale 
            di Bellinzona con il sostegno di BancaStato, nel quale ha trionfato il mio elaborato <em>Shh!</em>
          </p>
          <p>
            Quando se ne è presentata l'occasione, ho cominciato a trasmettere la mia passione anche a 
            ragazzi che volevano migliorare in italiano, raffinando via via le mie tecniche e giungendo 
            ad una profonda comprensione di quella che dovrebbe essere l'evoluzione delle lezioni frontali: 
            qualcosa di <strong>arricchente, interessante e personalizzato</strong>.
          </p>
          <p>
            Offro lezioni private e di rinforzo nella materia Italiano a ragazzi delle scuole medie, 
            seguendoli individualmente oppure in gruppo per mezzo del mio metodo che comprende pratiche 
            come <strong>interleaving</strong> e <strong>richiamo attivo</strong>.
          </p>
          <p>
            Attraverso la sezione blog di questo sito, inoltre, pubblico contenuti e analisi approfondite 
            che coprono tutti gli argomenti inerenti la lingua italiana.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
